import { AutomationsCapabilities, useFeatureAutomations } from "@/hooks/use-feature-automations";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { Navigate } from "react-router-dom";
import { workflowsUrl } from "@/utils/automations";
import type { FC, PropsWithChildren } from "react";

/**
 * Redirects to automations list if the user does not have the Webhooks capability.
 * Used to guard the /automations/webhooks route and its children.
 */
export const RequireWebhooksCapability: FC<PropsWithChildren> = ({ children }) => {
    const { capabilities, isLoading } = useFeatureAutomations();

    if (isLoading) {
        return <LoadingState />;
    }

    if (!capabilities.has(AutomationsCapabilities.Webhooks)) {
        return <Navigate to={workflowsUrl()} replace />;
    }

    return <>{children}</>;
};
